import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)
Vue.config.lang = localStorage.getItem("VOC-LANGUAGE") || "zh-cn"

Vue.locale("zh-cn", {
  ...require("./zh_cn")
})
Vue.locale("en", {
  ...require("./en")
})
